import React from 'react'

const AbsencesIcon = (
  <>
    <path
      d="M16.3913 4.21729H3.6087C3.44726 4.21729 3.29244 4.28142 3.17828 4.39557C3.06413 4.50972 3 4.66454 3 4.82598V16.3912C3 16.5526 3.06413 16.7075 3.17828 16.8216C3.29244 16.9358 3.44726 16.9999 3.6087 16.9999H16.3913C16.5527 16.9999 16.7076 16.9358 16.8217 16.8216C16.9359 16.7075 17 16.5526 17 16.3912V4.82598C17 4.66454 16.9359 4.50972 16.8217 4.39557C16.7076 4.28142 16.5527 4.21729 16.3913 4.21729Z"
      fill="#E6E6E6"
    />
    <path
      d="M10.0001 14.8695C10.0401 14.8696 10.0798 14.8617 10.1169 14.8463C10.1539 14.831 10.1875 14.8084 10.2158 14.7801L12.5176 12.4701C12.8524 12.1347 13.0415 11.6809 13.044 11.2071C13.0466 10.7332 12.8623 10.2775 12.5312 9.93855C12.2001 9.59961 11.7487 9.40479 11.2749 9.39629C10.8012 9.38779 10.3431 9.5663 10.0001 9.89314C9.65695 9.56627 9.19887 9.38777 8.72506 9.3963C8.25126 9.40483 7.7999 9.59971 7.46878 9.93871C7.13766 10.2777 6.95346 10.7335 6.95608 11.2074C6.95871 11.6813 7.14794 12.135 7.48279 12.4704L9.78427 14.7804C9.8126 14.8087 9.84624 14.8312 9.88327 14.8465C9.9203 14.8618 9.95999 14.8696 10.0001 14.8695Z"
      fill="#E86C60"
    />
    <path
      d="M3.6087 4.21729H16.3913C16.5527 4.21729 16.7076 4.28142 16.8217 4.39557C16.9359 4.50972 17 4.66454 17 4.82598V7.26076H3V4.82598C3 4.66454 3.06413 4.50972 3.17828 4.39557C3.29244 4.28142 3.44726 4.21729 3.6087 4.21729Z"
      fill="#E86C60"
    />
    <path
      d="M14.2608 5.73913V3.30435C14.2608 3.22363 14.2288 3.14622 14.1717 3.08914C14.1146 3.03207 14.0372 3 13.9565 3H13.3478C13.2671 3 13.1897 3.03207 13.1326 3.08914C13.0755 3.14622 13.0435 3.22363 13.0435 3.30435V5.73913C13.0435 5.81985 13.0755 5.89726 13.1326 5.95434C13.1897 6.01141 13.2671 6.04348 13.3478 6.04348H13.9565C14.0372 6.04348 14.1146 6.01141 14.1717 5.95434C14.2288 5.89726 14.2608 5.81985 14.2608 5.73913Z"
      fill="#444444"
    />
    <path
      d="M6.95653 5.73913V3.30435C6.95653 3.22363 6.92446 3.14622 6.86739 3.08914C6.81031 3.03207 6.7329 3 6.65218 3H6.04348C5.96277 3 5.88535 3.03207 5.82828 3.08914C5.7712 3.14622 5.73914 3.22363 5.73914 3.30435V5.73913C5.73914 5.81985 5.7712 5.89726 5.82828 5.95434C5.88535 6.01141 5.96277 6.04348 6.04348 6.04348H6.65218C6.7329 6.04348 6.81031 6.01141 6.86739 5.95434C6.92446 5.89726 6.95653 5.81985 6.95653 5.73913Z"
      fill="#444444"
    />
  </>
)

export default AbsencesIcon
